import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="admin">
      <aside className="admin__side">
        <Link to="/" className="admin__brand">
          Chacho<em>Phone</em> <span>Admin</span>
        </Link>

        <nav className="admin__nav">
          <NavLink to="/admin/productos" className={({ isActive }) => (isActive ? "active" : "")}>
            Productos
          </NavLink>
          <NavLink to="/admin/pedidos" className={({ isActive }) => (isActive ? "active" : "")}>
            Pedidos
          </NavLink>
        </nav>

        <div className="admin__side-foot">
          <p style={{ fontSize: "0.85rem", color: "var(--stone)" }}>{user?.email}</p>
          <button className="linkish" onClick={logout}>
            Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="admin__main">
        <Outlet />
      </main>
    </div>
  );
}
